export function updateContainerChildrenX(containerGroup, x) {
    return containerGroup.forEachChildrenSkipChild(((column, index) => {
        column.setAttribute("x", x), x += column.attribute.width;
    })), x;
}

export function updateContainerChildrenY(containerGroup, y) {
    return containerGroup.forEachChildrenSkipChild(((row, index) => {
        row.setAttribute("y", y), y += row.attribute.height;
    })), y;
}
//# sourceMappingURL=update-container.js.map
